import { useSyncExternalStore } from "react";

const listeners = new Set();
const standalone = window.matchMedia("(display-mode: standalone)");
let state = {
  prompt: null,
  installed: standalone.matches || window.navigator.standalone === true,
};

function updateState(changes) {
  state = { ...state, ...changes };
  listeners.forEach((listener) => listener());
}

// Captura antes do login: o Header e importado na inicializacao, mas monta depois.
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  updateState({ prompt: event });
});

window.addEventListener("appinstalled", () => {
  updateState({ prompt: null, installed: true });
});

standalone.addEventListener("change", (event) => {
  updateState({ installed: event.matches || window.navigator.standalone === true });
});

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

async function install() {
  const event = state.prompt;
  if (!event || state.installed) return "unavailable";

  // Cada evento so pode abrir uma solicitacao; libera apenas apos um novo evento.
  updateState({ prompt: null });
  await event.prompt();
  const { outcome } = await event.userChoice;
  if (outcome === "accepted") updateState({ installed: true });
  return outcome;
}

export default function usePwaInstall() {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot);
  // A disponibilidade vem do evento nativo, evitando um botao sem instalacao direta.
  return {
    installed: snapshot.installed,
    canInstall: window.isSecureContext && !!snapshot.prompt && !snapshot.installed,
    install,
  };
}
